import React from 'react';
import axios from 'axios';

class Services{

  /**
   *
   * Eshop services
   *
   */

  async getProducts() {

    const response = await fetch('https://api-balony.techcrowd.cz/api/product');

    const data = await response.json();

    return data;

  }

  async getProductsType(type: string) {

    let filter: string = ""

    if(type == 'private'){
        filter = '?filter={"filter": "1"}';
    }
    if(type == 'public'){
        filter = '?filter={"filter": "0"}';
    }

    const response = await fetch('https://api-balony.techcrowd.cz/api/product'+filter);

    const data = await response.json();

    return data;

  }

  async getProduct(id: any) {

    const response = await fetch('https://api-balony.techcrowd.cz/api/product/'+id);
    const data = await response.json();

    return data;

  }

  async getCart(id: any) {

    const response = await axios.get('https://api-balony.techcrowd.cz/api/cart/'+id,{});
    const data = await response;

    console.log('Cart return');
    console.log(data.data);

    return data.data;

  }

  async editCartItem(id: any,change: any) {

    axios.put('https://api-balony.techcrowd.cz/api/order-item/'+id,
      change
    ,
    {
      headers: { 'x-access-token': 'token' }
    }
    ).then((response) => {

      console.log(response);

      return response;

    })
    .catch((error) => {

      return error;

    });

  }

  async dropCartItem(id: any) {

    axios.delete('https://api-balony.techcrowd.cz/api/cart/'+id)
    .then((response) => {

      console.log(response);

      return response;

    })
    .catch((error) => {

      return error;

    });

  }

  async getShipmentList() {

    const response = await fetch('https://api-balony.techcrowd.cz/api/order-shipment');
    const data = await response.json();

    console.log(data)

    return data;

  }

  async getPaymentList() {

    const response = await fetch('https://api-balony.techcrowd.cz/api/order-payment');
    const data = await response.json();

    console.log(data)

    return data;

  }

  async getProductPlaces() {

    const response = await fetch('https://api-balony.techcrowd.cz/api/product-place');
    const data = await response.json();

    return data;

  }

  async addToCart(orderId: any, productId: string, idProductPlace: string, count: string) {

    axios.post('https://api-balony.techcrowd.cz/api/cart',
    {
      orderId: orderId,
      idProduct: productId.toString(),
      productPlace: idProductPlace,
      count: count
    },
    {
      headers: { 'x-access-token': 'token' }
    }
    )

      .then((response) => {

        localStorage.setItem('orderId',response.data.orderId);
        localStorage.setItem('orderIdInt',response.data.id);

        console.log(response);

        return response;

      })
      .catch((error) => {

        return error;

      });

  }

  async updateCart(cart: any) {

    const response = axios.put('https://api-balony.techcrowd.cz/api/cart',
      cart,
    {
      headers: { 'x-access-token': 'token' }
    }
    )

    const data = await response;

    return data;

  }

  async updateCartItem(cart: any, item: any, data: any) {

    const response = axios.put('https://api-balony.techcrowd.cz/api/cart/'+cart+'/item/'+item,
      data,
    {
      headers: { 'x-access-token': 'token' }
    }
    )

    const output = await response;

    return output;

  }

  async createOrder(id: any) {

    let apiUrl = 'https://api-balony.techcrowd.cz/api/orders/'+id+'/create'

    const response = await axios.put(apiUrl,
    {

    },
    {
      headers: { }
    }
    )

    const data = await response;

    return data;

  }

  async addVoucher(orderId: any, voucher: any) {

    try {

      const response = await axios.post('https://api-balony.techcrowd.cz/api/orders/'+orderId+'/add-voucher',
      {
        label: voucher,
      },
      {
        headers: { 'x-access-token': 'token' }
      })

      const data = await response;

      return data.data;

    } catch (err) {

        return "error"

    }

  }

  async removeVoucher(orderId: any) {

    const response = await axios.delete('https://api-balony.techcrowd.cz/api/orders/'+orderId+'/delete-voucher',
    {
      headers: { 'x-access-token': 'token' }
    })

    const data = await response;

    return data.data;

  }

  /**
   *
   * Reservations services
   *
   */

   async getFreeTerms() {

     const response = await fetch('https://api-balony.techcrowd.cz/api/product/terms?active=1');
     const data = await response.json();

     return data;

   }

   async getTerm(id: any) {

     const response = await fetch('https://api-balony.techcrowd.cz/api/product/terms/'+id);
     const data = await response.json();

     return data;

   }

   async getFreeTermsType(id: any) {

     const response = await fetch('https://api-balony.techcrowd.cz/api/product/'+id+'/terms');
     const data = await response.json();

     return data;

   }

   async createReservation(reservant: any, idTerm: any) {

     const response = await axios.post('https://api-balony.techcrowd.cz/api/order-reservation',
     {
       firstname: reservant.firstname,
       lastname: reservant.lastname,
       email: reservant.email,
       phone: reservant.phone,
       idTerm: Number(idTerm),
     },
     {
       headers: { 'x-access-token': 'token' }
     })

     const data = await response;

     return data.data;

   }

   async updateReservant(reservant: any, reservationId: any) {

     const response = await axios.put('https://api-balony.techcrowd.cz/api/order-reservation/'+reservationId,
     {
       firstname: reservant.firstname,
       lastname: reservant.lastname,
       email: reservant.email,
       phone: reservant.phone,
     },
     {
       headers: { 'x-access-token': 'token' }
     }
     )

     const data = await response;

     return data.data;

   }

   async updateReservationItem(orderItem: any, itemData: any) {

     const response = await axios.put('https://api-balony.techcrowd.cz/api/order-item/'+orderItem,

     itemData

     ,
     {
       headers: { 'x-access-token': 'token' }
     }
     )

     const data = await response;

     console.log(data);

   }

   async checkFlyNumber(flyNumber: any, idTerm: any) {

     const response = await axios.post('https://api-balony.techcrowd.cz/api/order-reservation/check-fly-number',
       {
         flyNumber: flyNumber,
         idTerm: Number(idTerm)
       },
       {
         headers: { 'x-access-token': 'token' }
       }
     ).catch((error) => {

       return error

     });

     const data = await response;

     return data.data



   }

   async addReservation(flyNumber: any, idTerm: any, reservationId: any) {

     const response = await axios.put('https://api-balony.techcrowd.cz/api/order-reservation/'+reservationId,
     {
       idTerm: Number(idTerm),
       flyNumber: flyNumber
     },
     {
       headers: { 'x-access-token': 'token' }
     }
     )

     const data = await response;

     return data.data;

   }


}

export default Services;
